import { render, staticRenderFns } from "./StoryboardEditorPage.vue?vue&type=template&id=1557b4e9&scoped=true"
import script from "./StoryboardEditorPage.vue?vue&type=script&lang=js"
export * from "./StoryboardEditorPage.vue?vue&type=script&lang=js"
import style0 from "./StoryboardEditorPage.vue?vue&type=style&index=0&id=1557b4e9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1557b4e9",
  null
  
)

export default component.exports